import React from 'react';

import Avatar from 'material-ui/Avatar';

import AccountCircle from 'material-ui/svg-icons/action/account-circle';

function ParseAvatar(props) {
  const file = props.avatar != null ? props.avatar.get('image') : props.file;

  var content = null;
  if (file != null) {
    content = <Avatar src={file.url()} {...props} />;
  } else {
    content = <Avatar icon={ <AccountCircle /> } {...props } />;
  }
  
  return content;
}

export default ParseAvatar;


// WEBPACK FOOTER //
// ./src/components/ParseAvatar.js